import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import AccessibilityBar from "@/components/AccessibilityBar";
import Footer from "@/components/Footer";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import Home from "@/pages/Home";
import Notices from "@/pages/Notices";
import Courses from "@/pages/Courses";
import Departments from "@/pages/Departments";
import Students from "@/pages/Students";
import RoutinePage from "@/pages/RoutinePage";
import SyllabusPage from "@/pages/SyllabusPage";
import ProspectusPage from "@/pages/ProspectusPage";
import MarksheetPage from "@/pages/MarksheetPage";
import IdCard from "@/pages/IdCard";
import AdmissionPage from "@/pages/AdmissionPage";
import RegistrationPage from "@/pages/RegistrationPage";
import ApplicationStatus from "@/pages/ApplicationStatus";
import CardView from "@/pages/CardView";
import Library from "@/pages/Library";
import Librarian from "@/pages/Librarian";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children, chrome = true }) {
  return (
    <>
      {chrome && <AccessibilityBar />}
      {chrome && <Navbar />}
      <main id="main-content">{children}</main>
      {chrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
          <SmoothScroll>
            <ScrollToTop />
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/notice" element={<Layout><Notices /></Layout>} />
              <Route path="/course" element={<Layout><Courses /></Layout>} />
              <Route path="/department" element={<Layout><Departments /></Layout>} />
              <Route path="/student" element={<Layout><Students /></Layout>} />
              <Route path="/routine" element={<Layout><RoutinePage /></Layout>} />
              <Route path="/syllabus" element={<Layout><SyllabusPage /></Layout>} />
              <Route path="/prospectus" element={<Layout><ProspectusPage /></Layout>} />
              <Route path="/marksheet" element={<Layout><MarksheetPage /></Layout>} />
              <Route path="/admission" element={<Layout><AdmissionPage /></Layout>} />
              <Route path="/registration" element={<Layout><RegistrationPage /></Layout>} />
              <Route path="/application-status" element={<Layout><ApplicationStatus /></Layout>} />
              <Route path="/id-card" element={<Layout><IdCard /></Layout>} />
              <Route path="/card/:id" element={<Layout><CardView /></Layout>} />
              <Route path="/library" element={<Layout><Library /></Layout>} />
              <Route path="/librarian" element={<Layout chrome={false}><Librarian /></Layout>} />
              <Route path="/login" element={<Layout chrome={false}><Login /></Layout>} />
              <Route path="/admin" element={<Layout chrome={false}><Admin /></Layout>} />
            </Routes>
          </SmoothScroll>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
